import styles from './cta.module.css';

const CTA = ({ text, CTA }) => {
    return (
            <div className={styles.cta}>
                <p>{text}</p>
                <ul>
                    {Array.isArray(CTA) && CTA.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            </div>
        
    );
};

export default CTA;
